enum PaymentConfirmationValidationErrorEnum {
    ACCOUNT_NUMBER_FORMAT_INVALID,
    ACCOUNT_NUMBER_DOES_NOT_MATCH_BANK,
    BANK_CODE_DOES_NOT_MATCH_BANK,
    BANK_CODE_FORMAT_INVALID,
}

export default PaymentConfirmationValidationErrorEnum;
